import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Workspace.svg?component
var Workspace_exports = /* @__PURE__ */ __exportAll({
	default: () => Workspace_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M20.25 3.75v19.5M3.75 3.75h16.5m-16.5 19.5V3.75m16.5 19.5H3.75m16.5-19.5H3.75l1.5-3h13.5zM.75 23.25h22.5m-9-2.25a2.25 2.25 0 0 0-4.5 0v2.25h4.5zM7.5 7.13a.37.37 0 1 1 0-.75m0 .75a.37.37 0 1 0 0-.75m4.5.75a.38.38 0 0 1 0-.75m0 .75a.38.38 0 0 0 0-.75m4.5.75a.38.38 0 0 1 0-.75m0 .75a.38.38 0 0 0 0-.75m-9 5.25a.38.38 0 0 1 0-.76m0 .76a.38.38 0 0 0 0-.76m4.5.76a.38.38 0 0 1 0-.76m0 .76a.38.38 0 0 0 0-.76m4.5.76a.38.38 0 0 1 0-.76m0 .76a.38.38 0 0 0 0-.76m-9 5.26a.38.38 0 0 1 0-.75m0 .75a.38.38 0 0 0 0-.75m4.5.75a.38.38 0 0 1 0-.75m0 .75a.38.38 0 0 0 0-.75m4.5.75a.38.38 0 0 1 0-.75m0 .75a.38.38 0 0 0 0-.75" }, null, -1)])]);
}
var Workspace_default = { render: render$1 };
//#endregion
export { Workspace_exports, Workspace_default as default, render$1 as render };

//# sourceMappingURL=Workspace.svg.virtual.js.map